// extracted by mini-css-extract-plugin
module.exports = {"tokenSlotCard":"NFTSlot_tokenSlotCard_14_Pa"};